'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowSellerButton = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(FollowSellerButton, _Component);

    function FollowSellerButton() {
        (0, _classCallCheck3.default)(this, FollowSellerButton);
        return (0, _possibleConstructorReturn3.default)(this, (FollowSellerButton.__proto__ || (0, _getPrototypeOf2.default)(FollowSellerButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(FollowSellerButton, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['children', 'followed']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                followed = _props.followed;


            if (children) {
                return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_Button2.default, {
                    primary: !followed,
                    secondary: followed
                }, void 0, children));
            }

            return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_Button2.default, {
                primary: !followed,
                secondary: followed
            }, void 0, !followed ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'follow'
            }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'following'
            })));
        }
    }]);
    return FollowSellerButton;
}(_react.Component), _class.defaultProps = {
    followed: false
}, _temp);
exports.default = FollowSellerButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowSeller/FollowSellerButton.js
// module id = iwOt
// module chunks = 46